// extracted by mini-css-extract-plugin
module.exports = {"summary":"summary--125pF"};